import React from "react";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import Currency from "../../../shared/Currency";
import DisplayField from "../DisplayField";

const Financials = ({ event, styles }) => {
  const financialItemStyle = {
    borderBottom: "1px solid var(--Neutrals-300, #E0E1E2)",
    padding: "4px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  return (
    <FormGroup className={styles.dataValuePair}>
      <ControlLabel className={styles.dataValuePairLabel}>
        Financials
      </ControlLabel>
      <FormControl.Static
        className={styles.dataValuePairValue}
        componentClass={"div"}
      >
        <div>
          {!!event.job.jobTotal && (
            <DisplayField group="financial" field="jobRevenue">
              <div style={financialItemStyle}>
                <span>Revenue:</span>
                <Currency value={event.job.jobTotal} />
              </div>
            </DisplayField>
          )}
          {event.job.profit && !!event.job.profit.proposedProfit && (
            <DisplayField group="financial" field="jobProposedProfit">
              <div style={financialItemStyle}>
                <span>Prop Pft:</span>
                <Currency value={event.job.profit.proposedProfit} />
              </div>
            </DisplayField>
          )}
          {event.job.profit && !!event.job.profit.actualProfit && (
            <DisplayField group="financial" field="jobActualProfit">
              <div style={financialItemStyle}>
                <span>Actual Pft:</span>
                <Currency value={event.job.profit.actualProfit} />
              </div>
            </DisplayField>
          )}
          {event.job.capacities && !!event.job.capacities.laborAmount && (
            <DisplayField group="financial" field="jobEstimatedLabor">
              <div style={financialItemStyle}>
                <span>Est Labor:</span>
                <Currency value={event.job.capacities.laborAmount} />
              </div>
            </DisplayField>
          )}
        </div>
      </FormControl.Static>
    </FormGroup>
  );
};

export default Financials;
